import styled from "styled-components";

export const StyledH2 = styled.h2`
  font-weight: 200;
  font-size: var(--hero-h2-fs);
  letter-spacing: 4px;
`;

export const StyledSecondH2 = styled.h2`
  font-size: var(--marketing-h2-fs);
  letter-spacing: 1px;
`;
